Ext.define('SA.view.TableDragCellCloneFactory', {
    singleton: true,

    createClone({el, mouseDownOffset}) {
        var cloneEl = el.cloneNode(true),
            clone = new SA.view.TableDragCellClone({el: cloneEl, mouseDownOffset});

        cloneEl.classList.add('sa-table-drag-cell-clone');
        document.body.appendChild(cloneEl);

        return clone;
    }
});